import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Button, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { getAllSellItem, getCategories, getItems } from "store/actions";
import { Link } from "react-router-dom";
import CategoryCard from "Pages/category/categoryCard";
function SampleNextArrow1(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

function SamplePrevArrow2(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}
const settings = {
  dots: false,
  infinite: false,
  autoplay: false,

  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow1 />,
  prevArrow: <SamplePrevArrow2 />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
export default function AuctionCardNFT(props) {
  let dispatch = useDispatch();
  const [filter, setfilter] = useState({
    search: "auction",
    limit: 4, // changes 1000000
    orderBy: "_id",
    order: -1,
    page: 1,
    author: "",
    collectionId: "",
    fields: [],
    fileType: [],
    isVarified: false,
    getNew: false,
    isMore: false,
  });
  const { home } = useSelector((state) => state);
  const { explore } = useSelector((state) => state?.home);
  const [auctionItem, setAuctionItem] = useState([])
  const [auctionData, setAuctionData] = useState([])
  // const { sellItems } = useSelector((state) => state?.SellItems);
  const [fields, setFields] = useState({
    search: "auction",
    limit: 4,  // changes 1000000
    order: -1,
    fields: [{
      fieldName: "",
      fieldValue: ""
    },
    {
      fieldName: "",
      fieldValue: ""
    }
    ]
  });


  // useEffect(() => {
  //   setAuctionItem(items?.filter((item) => item?.saleType === "auction"))
  //   let i = 4
  //   let k = 0
  //   k = items?.length - 1
  //   while (i--) {
  //     if (items[k]?.saleType === "auction" && items?.putOnsale === true)
  //       auctionItem.push(items[k])
  //   }
  // }, [items]);


  // useEffect(() => {

  //   const x = sellItems.filter((item) => item?.sellType === "auction")
  //   setAuctionData(x)

  // }, [sellItems]);




  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);
  useEffect(() => {
    const auctionDataCallback = (res) => {
      if (res.status === "success") {
        setAuctionData(res.data.data)
      }
    }
    dispatch(getAllSellItem(fields, auctionDataCallback));
  }, [fields, dispatch]);


  // useEffect(() => {
  //   dispatch(getExplore(filter));
  // }, [filter, dispatch]);

  // useEffect(() => {
  //   if (home?.explore) {
  //     if (filter.isMore) {
  //       setexplore((prevState) => [...prevState, ...home?.explore]);
  //     } else {
  //       setexplore(home?.explore);
  //     }
  //   }
  // }, [home?.explore]);

  // useEffect(() => {
  //   if (user?._id) {
  //     setfilter((prevState) => ({
  //       ...prevState,
  //       collectedAuthor: null,
  //       createdAuthor: null,
  //       author: user?._id,
  //       page: 1,
  //       isMore: false,
  //     }));
  //   }
  // }, [user?._id]);

  const showMoreItems = (evt) => {
    evt.preventDefault();
    setfilter((prevState) => ({
      ...prevState,
      page: prevState.page + 1,
      isMore: true,
    }));
  };
  return (
    <section className="contailer-fluid liveAuction">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="DigitalArtcollection-head d-flex align-items-baseline justify-content-between mb-2">
              <h2>Current Live Auctions</h2>
              <Link className="viewText d-flex align-items-center gap-2" to="/auction-view" state={{ auctionItem }}  >View all <svg width="30" height="16" viewBox="0 0 30 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.01214 7.00007C0.459892 6.99337 0.00677631 7.43562 7.36713e-05 7.98786C-0.00662897 8.54011 0.43562 8.99322 0.987864 8.99993L1.01214 7.00007ZM29.6985 9.05548C30.0937 8.66972 30.1014 8.0366 29.7156 7.64137L23.4294 1.20064C23.0436 0.805404 22.4105 0.79772 22.0153 1.18348C21.62 1.56923 21.6123 2.20235 21.9981 2.59759L27.5859 8.32268L21.8608 13.9105C21.4656 14.2962 21.4579 14.9293 21.8436 15.3246C22.2294 15.7198 22.8625 15.7275 23.2577 15.3417L29.6985 9.05548ZM0.987864 8.99993L28.9879 9.33977L29.0121 7.33991L1.01214 7.00007L0.987864 8.99993Z" fill="black" />
              </svg>
              </Link>
            </div>

            {/* <div className="card_nfd_wr" hidden>

              {Explore && Explore?.length > 0 ? (
                <>
                  {Explore?.map((nftData, idx) => {
                    return (
                      <div key={idx} className="digitailart-tabbing">
                        <ExploreCard nftData={nftData} />
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className="mt-2 w-100">
                  <p className="=home_text">No Live Auction Found!!</p>
                </div>
              )}
            </div> */}
            <div className="liveActionBox">
              <Row>


                {auctionData && auctionData?.length > 0 ? (
                  <Slider {...settings}>
                    {auctionData?.map((nftData, idx) => {
                      return (
                        <>
                          {/* <AuCard key={idx} data={nftData} /> */}
                          <CategoryCard key={idx} data={nftData} />
                        </>
                      )
                    })}
                  </Slider>
                )

                  : (
                    <div className="text-center d-grid justify-content-center dataNotFound py-5">
                      <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                      <h3>No Artworks Available</h3>
                    </div>
                  )}



              </Row>
            </div>

            {explore?.length < home?.totalExplore && (
              <div className="text-center show-wrap">
                <Button onClick={showMoreItems} className="showmore">
                  Show More Item
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
